module.exports = __webpack_public_path__ + "static/img/zptp.9cbef3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/zptp.jpg
// module id = lY+e
// module chunks = 11